// Front End Only Mode lets the site run on a computer that doesn't have Django
// set up. Every request to the back end is answered by `fake_api.ts` instead.
// It's only available on the Vite development server.

const frontEndOnlyModeLocalStorageKey = "frontEndOnlyMode";

export const frontEndOnlyModeAvailable = import.meta.env.DEV;

export function frontEndOnlyModeIsOn() {
  return (
    frontEndOnlyModeAvailable &&
    localStorage.getItem(frontEndOnlyModeLocalStorageKey) === "true"
  );
}

export function turnOnFrontEndOnlyMode() {
  localStorage.setItem(frontEndOnlyModeLocalStorageKey, "true");
  window.location.reload();
}

export function turnOffFrontEndOnlyMode() {
  localStorage.removeItem(frontEndOnlyModeLocalStorageKey);
  window.location.assign("/");
}
